import React, { useEffect, useState } from 'react';
import clsx from "clsx";
import { useIntl } from "react-intl";
import Config from "../../config";
import axios from '../../utils/axios';
import { EyeFilled } from "@ant-design/icons";
import { Form, Spin, Table, Input, Layout, Checkbox, Select } from "antd";
import styled from "styled-components";
import { getOpportunity, getProgramById, toggleSpinner, getIndicatorAnswers } from "../../redux/actions";
import StyledText from "../../components/StyledText";
import CustomModal from '../../components/Modal';
import Button from "../../components/Button";
import { getLocalStorageItem, numericValidator } from "../../utils/utilities";
import {
    toggleSpinnerSelector,
    indicatorDataSelector
} from "../../redux/selectors";
import {
    useAppDispatch,
    useAppSelector
} from "../../redux/store";
const { TextArea } = Input;
const { Option } = Select;

const getKeysArray = (objArray) => {
    const keysArray = [];
    if (objArray?.length) {
        objArray.forEach((obj) => {
            const keys = Object.keys(obj);
            if (obj[keys[0]] === 'Y') {
                keysArray.push(keys[0]);
            }
        });
        return keysArray;
    }
}

const CharityIndicatorsPreview = ({ className }) => {
    const baseClassName = clsx("charityIndicatorsPreview", className);
    const intl = useIntl();
    const [indicatorsPopUpData, setIndicatorsPopUpData] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [unit, setUnit] = useState('');
    const indicators = useAppSelector(indicatorDataSelector) || {};
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const showSpinner = useAppSelector(toggleSpinnerSelector);
    const programReviewDetails = JSON.parse(getLocalStorageItem('programReviewDetails') || '{}');
    const { opportunityId, programID } = programReviewDetails || {};

    useEffect(() => {
        if (opportunityId) {
            dispatch(getOpportunity(opportunityId));
        }
    }, [opportunityId, programID]);

    useEffect(() => {
        if (programID) {
            document.documentElement.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            dispatch(getProgramById(programID));
            dispatch(getIndicatorAnswers({
                programID,
                opportunityID: opportunityId
            }))
        }
    }, [programID]);

    const getColumnData = (list) => {
        if (list?.length > 0) {
            return list?.map((item, idx) => {
                const {
                    name,
                    description,
                    isMandatory,
                    targetRequired,
                    targetLevel,
                    status,
                    linkedObjective,
                    linkedOutcome,
                    objectiveName,
                    outcomeName,
                    ID,
                    unit,
                    initialStatus,
                    finalStatus,
                    startingLevel,
                    indicatorType,
                    startingLevelArray,
                    targetLevelArray,
                    startingLevelList,
                    targetLevelList
                } = item || {};
                return {
                    key: idx,
                    name,
                    description,
                    isMandatory,
                    targetRequired,
                    targetLevel,
                    status,
                    linkedObjective,
                    linkedOutcome,
                    objectiveName,
                    outcomeName,
                    ID,
                    unit,
                    initialStatus,
                    finalStatus,
                    startingLevel,
                    indicatorType,
                    startingLevelArray,
                    targetLevelArray,
                    startingLevelList,
                    targetLevelList
                };
            });
        }
        return null;
    };

    const resetAllFields = () => {
        form.setFieldsValue({
            startingLevel: undefined,
            targetLevel: undefined,
            evidenceList: undefined,
            approachDescription: undefined,
        });
        setUnit(null);
        setIsModalVisible(false);
    };

    const renderEvidenceSection = (param) => {
        const CheckboxGroup = Checkbox.Group;
        const options = param;
        return (
            options?.length > 0 && (
                <div style={{ marginBottom: '12px', display: 'flex', flexDirection: 'column' }}>
                    <StyledText as="p" variant="B3d" className='mainTitle'>
                        {intl.formatMessage({ id: "evidence" })}
                    </StyledText>
                    <StyledText as="p" variant="B3" className='mainTitle'>
                        {intl.formatMessage({ id: "please_confirm_that_you_can_provide_any_of_following_evidence_items" })}
                    </StyledText>
                    <div style={{ display: 'flex', margin: '5px 0', alignItems: 'center' }} className='checkboxParentContainer'>
                        <Form.Item
                            name="evidenceList"
                            rules={[
                                {
                                    validator: (_, value) => {
                                        if (!value || value.length < options.length) {
                                            return Promise.reject(
                                                new Error(intl.formatMessage({ id: 'select_all_options' }))
                                            );
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ]}
                            className='checkboxParentContainerFormItem'
                            style={{ marginBottom: '0px' }}
                        >
                            <CheckboxGroup className="checkboxContainer" style={{ display: 'flex', flexDirection: 'column' }}>
                                {options?.length > 0 &&
                                    options.map((parent) => (
                                        <Checkbox
                                            key={parent}
                                            value={parent}
                                            style={{ marginLeft: '0', fontSize: '16px', marginBottom: '10px' }}
                                            disabled
                                        >
                                            <StyledText as="span" variant="B3">
                                                {parent}
                                            </StyledText>
                                        </Checkbox>
                                    ))
                                }
                            </CheckboxGroup>
                        </Form.Item>
                    </div>
                </div>
            )
        );
    };

    const getOptionalSection = (startingRequired, targetRequired, indicatorType) => (startingRequired === 'Y' || targetRequired === 'Y')
        && ['percentage', 'number']?.includes(indicatorType);


    const getAddOnAfter = (unit, indicatorType) => (unit || indicatorType === 'percentage' || indicatorType === 'array-percentage' ? (
        <span>{`${unit || '%'}`}</span>
    ) : undefined);

    const renderModal = () => {
        const {
            name,
            description,
            indicatorType,
            startingRequired,
            targetRequired,
            predefinedList,
            evidenceRequiredList,
            startingLevel,
            targetLevel,
            baseLevel,
            approachDescription,
            startingLevelList,
            targetLevelList,
            evidenceList,
            absoluteChange,
            relativeChange
        } = indicatorsPopUpData || {};

        const showOptionalSection = getOptionalSection(
            startingRequired,
            targetRequired,
            indicatorType
        );
        const useArrayFields = indicatorType === 'pre-def-multi';
        const mode = useArrayFields ? 'multiple' : undefined;
        return (
            <CustomModal
                title={intl.formatMessage({ id: 'create_indicator' })}
                open={isModalVisible}
                onCancel={() => resetAllFields()}
                className="indicatorPop"
            >
                {showSpinner ? (
                    <div className="overlay">
                        <Spin className="spinner" size="large" spinning={showSpinner} />
                    </div>
                ) :
                    <>
                        <Form form={form} initialValues={{
                            baseLevel: baseLevel
                        }}>
                            <Layout className="dropDownBackgroundModal">
                                <div>
                                    <StyledText as="span" variant="B3d">
                                        {intl.formatMessage({ id: "indicator_name" })}
                                        {': '}
                                    </StyledText>
                                    <StyledText as="span" variant="B3">
                                        {name}
                                    </StyledText>
                                </div>
                                <div>
                                    <StyledText as="span" variant="B3d">
                                        {intl.formatMessage({ id: "description" })}
                                        {': '}
                                    </StyledText>
                                    <StyledText as="span" variant="B3">
                                        {description}
                                    </StyledText>
                                </div>
                                <StyledText as="span" variant="B3d">
                                    {intl.formatMessage({ id: "measuring_progress" })}
                                </StyledText>
                                <div>
                                    {['percentage', 'number']?.includes(indicatorType) && (
                                        <>
                                            {startingRequired === 'Y' && (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <Form.Item
                                                        className="dFlex inputStyle"
                                                        label={<StyledText as="p" variant="B3">
                                                            {intl.formatMessage({
                                                                id: 'starting_number_level_of_your_indicator',
                                                            })}
                                                        </StyledText>
                                                        }
                                                        name="startingLevel"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: intl.formatMessage({
                                                                    id: 'please_enter_numeric_value',
                                                                }),
                                                            },
                                                            { validator: numericValidator, message: intl.formatMessage({ id: 'please_enter_numeric_value' }) }
                                                        ]}
                                                        initialValue={startingLevel}
                                                    >
                                                        <Input
                                                            className="inputAlign"
                                                            placeholder={intl.formatMessage({
                                                                id: 'please_enter',
                                                            })}
                                                            disabled
                                                            addonAfter={getAddOnAfter(unit, indicatorType)}
                                                        />
                                                    </Form.Item>
                                                </div>
                                            )}
                                            {targetRequired === 'Y' && (
                                                <Form.Item
                                                    className="dFlex marginBottomStandard inputStyle"
                                                    label={<StyledText as="p" variant="B3">
                                                        {intl.formatMessage({
                                                            id: 'target_number_or_level_to_reach',
                                                        })}
                                                    </StyledText>}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: intl.formatMessage({
                                                                id: 'please_enter_numeric_value',
                                                            }),
                                                        },
                                                        { validator: numericValidator, message: intl.formatMessage({ id: 'please_enter_numeric_value' }) }
                                                    ]}
                                                    initialValue={targetLevel}
                                                    name="targetLevel"
                                                >
                                                    <Input
                                                        className="inputAlign"
                                                        placeholder={intl.formatMessage({
                                                            id: 'please_enter',
                                                        })}
                                                        disabled
                                                        addonAfter={getAddOnAfter(unit, indicatorType)}
                                                    />
                                                </Form.Item>
                                            )}
                                        </>
                                    )}
                                    {(showOptionalSection) && (
                                        <div style={{ alignItems: 'flex-end' }} className='estimateTextContainer'>
                                            {(typeof absoluteChange === 'number') && (
                                                <><StyledText as="p" variant="B3b" className='customModalTitle'>
                                                    {intl.formatMessage({
                                                        id: 'the_target_we_aim_to_reach_is_employed_from_the_starting_number_level',
                                                    }).replace(
                                                        'employedNumber',
                                                        absoluteChange > 0
                                                            ? `+${absoluteChange}`
                                                            : `${absoluteChange}`
                                                    )}
                                                </StyledText>
                                                    <Form.Item
                                                        className="dFlexTop whiteSpaceBreak marginBottomStandard optional inputStyle"
                                                        labelCol={{ span: 12 }}
                                                        wrapperCol={{ span: 12 }}
                                                        label={(
                                                            <div style={{
                                                                display: 'flex', flexDirection: 'column', textAlign: 'left', lineHeight: '18px'
                                                            }}
                                                            ><StyledText as="p" variant="B3">
                                                                    {intl.formatMessage({
                                                                        id: 'optional_title',
                                                                    })}:
                                                                </StyledText>
                                                                <StyledText as="p" variant="B3" className='estimateText'>
                                                                    {intl.formatMessage({
                                                                        id: 'estimate_what_the_level_would_be',
                                                                    })}
                                                                </StyledText>
                                                            </div>
                                                        )}
                                                        initialValue={baseLevel}
                                                        name="baseLevel"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                message: intl.formatMessage({
                                                                    id: 'please_enter',
                                                                }),
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            className="inputAlign"
                                                            placeholder={intl.formatMessage({
                                                                id: 'please_enter',
                                                            })}
                                                            disabled
                                                            value={baseLevel}
                                                        />
                                                    </Form.Item>
                                                    {typeof relativeChange === 'number'
                                                        && !isNaN(relativeChange)
                                                        && typeof absoluteChange === 'number' && (
                                                            <StyledText as="p" variant="B3b" className='customModalTitle'>
                                                                {intl
                                                                    .formatMessage({
                                                                        id: 'your_total_impact_will_be_employed',
                                                                    })
                                                                    .replace(
                                                                        'impactNumber',
                                                                        relativeChange > 0
                                                                            ? `+${relativeChange}`
                                                                            : `${relativeChange}`
                                                                    )}
                                                            </StyledText>
                                                        )}
                                                </>
                                            )}
                                            {indicatorType === 'qualitative' && (
                                                <>
                                                    {startingRequired === 'Y' && (
                                                        <Form.Item
                                                            className="dFlex"
                                                            label={intl.formatMessage({
                                                                id: 'describe_the_starting_situation',
                                                            })}
                                                            name="startingLevel"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: intl.formatMessage({
                                                                        id: 'please_enter',
                                                                    }),
                                                                },
                                                            ]}
                                                            initialValue={startingLevel}
                                                        >
                                                            <TextArea
                                                                className="textContent"
                                                                maxLength="300"
                                                                placeholder="please_enter"
                                                                rows={2}
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    )}
                                                    {targetRequired === 'Y' && (
                                                        <Form.Item
                                                            className="dFlex marginBottom"
                                                            label={intl.formatMessage({
                                                                id: 'describe_the_final_situation',
                                                            })}
                                                            name="targetLevel"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: intl.formatMessage({
                                                                        id: 'please_enter',
                                                                    }),
                                                                },
                                                            ]}
                                                            initialValue={targetLevel}
                                                        >
                                                            <TextArea
                                                                className="textContent"
                                                                maxLength="300"
                                                                placeholder="please_enter"
                                                                rows={2}
                                                                disabled
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                    {['pre-def-multi', 'pre-def-single']?.includes(indicatorType) && (
                                        <>
                                            {startingRequired === 'Y' && (
                                                <Form.Item
                                                    className="dFlex"
                                                    label={intl.formatMessage({
                                                        id: 'describe_the_starting_situation',
                                                    })}
                                                    name={useArrayFields ? 'startingLevelList' : 'startingLevel'}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: intl.formatMessage({
                                                                id: 'please_enter',
                                                            }),
                                                        },
                                                    ]}
                                                    initialValue={useArrayFields
                                                        ? startingLevelList
                                                        : startingLevel}
                                                >
                                                    <Select
                                                        placeholder={intl.formatMessage({ id: 'select_title' })}
                                                        className="selectBox"
                                                        mode={mode}
                                                        disabled
                                                    >
                                                        {predefinedList?.length > 0
                                                            && predefinedList.map((item) => (
                                                                <Option key={item} value={item}>
                                                                    {item}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                            {targetRequired === 'Y' && (
                                                <Form.Item
                                                    className="dFlex marginBottom"
                                                    label={intl.formatMessage({
                                                        id: 'describe_the_final_situation',
                                                    })}
                                                    name={useArrayFields ? 'targetLevelList' : 'targetLevel'}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: intl.formatMessage({
                                                                id: 'please_enter',
                                                            }),
                                                        },
                                                    ]}
                                                    initialValue={useArrayFields
                                                        ? targetLevelList
                                                        : targetLevel}
                                                >
                                                    <Select
                                                        placeholder={intl.formatMessage({ id: 'select_title' })}
                                                        className="selectBox"
                                                        mode={mode}
                                                        disabled
                                                    >
                                                        {predefinedList?.length > 0
                                                            && predefinedList.map((item) => (
                                                                <Option key={item} value={item}>
                                                                    {item}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </>
                                    )}
                                    {['array-percentage', 'array-number']?.includes(indicatorType) && (
                                        <>
                                            {startingRequired === 'Y' && (
                                                <>
                                                    <span>
                                                        {intl.formatMessage({
                                                            id: 'describe_the_starting_situation',
                                                        })}
                                                    </span>
                                                    {predefinedList?.length > 0
                                                        && predefinedList.map((item) => (
                                                            <div style={{ display: 'flex' }} key={item}>
                                                                <Form.Item
                                                                    key={item}
                                                                    className="dFlex marginBottomStandard inputStyle"
                                                                    name={`startingLevel-${item}`}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: intl.formatMessage({
                                                                                id: indicatorType === 'array-number' ? 'please_enter_number' : 'please_enter',
                                                                            }),
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Input
                                                                        placeholder={intl.formatMessage({
                                                                            id: 'enter_title',
                                                                        })}
                                                                        addonAfter={getAddOnAfter(unit, indicatorType)}
                                                                        disabled
                                                                    />
                                                                </Form.Item>
                                                                <div style={{ display: 'flex', margin: '9px' }}>{item}</div>
                                                            </div>
                                                        ))}
                                                </>
                                            )}
                                            {targetRequired === 'Y' && (
                                                <>
                                                    <span>
                                                        {intl.formatMessage({
                                                            id: 'describe_the_final_situation',
                                                        })}
                                                    </span>
                                                    {predefinedList?.length > 0
                                                        && predefinedList.map((item) => (
                                                            <div style={{ display: 'flex' }} key={item}>
                                                                <Form.Item
                                                                    key={item}
                                                                    className="dFlex marginBottomStandard inputStyle"
                                                                    name={`targetLevel-${item}`}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: intl.formatMessage({
                                                                                id: indicatorType === 'array-number' ? 'please_enter_number' : 'please_enter',
                                                                            }),
                                                                        },
                                                                        { validator: numericValidator, message: intl.formatMessage({ id: 'please_enter_numeric_value' }) }
                                                                    ]}
                                                                >
                                                                    <Input
                                                                        placeholder={intl.formatMessage({
                                                                            id: 'enter_title',
                                                                        })}
                                                                        addonAfter={getAddOnAfter(unit, indicatorType)}
                                                                        disabled
                                                                    />
                                                                </Form.Item>
                                                                <div style={{ display: 'flex', margin: '9px' }}>{item}</div>
                                                            </div>
                                                        ))}
                                                </>
                                            )}
                                        </>
                                    )}
                                    {renderEvidenceSection(evidenceList, startingRequired, targetRequired, evidenceRequiredList)}
                                </div>
                                <StyledText as="p" variant="B3d">
                                    {intl.formatMessage({ id: "how_will_you_gather_evidence" })}
                                </StyledText>
                                <Form.Item
                                    className="dFlex whiteSpaceBreak marginBottom"
                                    name="approachDescription"
                                    rules={[
                                        {
                                            required: true,
                                            message: intl.formatMessage({ id: 'please_enter' }),
                                        },
                                    ]}
                                    initialValue={approachDescription}
                                >
                                    <TextArea
                                        style={{ width: '530px' }}
                                        placeholder={intl.formatMessage({
                                            id: 'enter_description',
                                        })}
                                        disabled
                                    />
                                </Form.Item>
                            </Layout>
                        </Form>
                    </>}
            </CustomModal>
        );
    };

    const transformObject = (inputObj, check) => Object.keys(inputObj).reduce((result, key) => {
        const newKey = check ? `targetLevel-${key}` : `startingLevel-${key}`;
        result[newKey] = inputObj[key];
        return result;
    }, {});

    const handleModalResponse = (res) => {
        if (res?.data?.indicator) {
            setIndicatorsPopUpData([])
            dispatch(toggleSpinner(false));
            setIndicatorsPopUpData(res.data.indicator);
            if (
                (res?.data?.indicator?.indicatorType === 'array-percentage'
                    || res?.data?.indicator?.indicatorType === 'array-number')
                && res?.data?.indicator?.startingLevelArray
                && res?.data?.indicator?.targetLevelArray
            ) {
                const staringLevel = transformObject(
                    res?.data?.indicator?.startingLevelArray
                );
                const targetLevel = transformObject(
                    res?.data?.indicator?.targetLevelArray,
                    true
                );
                const mergedArray = { ...staringLevel, ...targetLevel };
                form.setFieldsValue(mergedArray);
            }
            const keysArray = getKeysArray(res?.data?.indicator?.answerEvidenceRequiredList) || [];
            if (keysArray?.length > 0) {
                form.setFieldsValue({
                    evidenceList: keysArray,
                });
            }
            form.setFieldsValue({
                approachDescription: res?.data?.indicator?.approachDescription,
                startingLevel: res?.data?.indicator?.startingLevel,
                targetLevel: res?.data?.indicator?.targetLevel
            });
            setTimeout(() => {
                setIsModalVisible(true);
            }, 500);
        }
    };

    const handleStatusClick = (report) => {
        resetAllFields();
        dispatch(toggleSpinner(true));
        setUnit(unit)
        const indicatorUrl = `${Config?.url.getEditIndicatorAnswers}?indicatorAnswerID=${report?.ID}`;
        axios.get(indicatorUrl, handleModalResponse);
    };

    const generalIndicatorsColumns = [
        {
            title: intl.formatMessage({ id: 'indicator' }),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: intl.formatMessage({ id: 'starting' }),
            dataIndex: 'startingLevel',
            key: 'startingLevel',
            render: (text, report) => {
                return (report?.indicatorType === "array-number" || report?.indicatorType === "array-percentage") && report?.startingLevelArray ? (
                    Object.entries(report?.startingLevelArray)?.map(([key, value]) => <div key={value}
                        className="statusButton"
                    ><span className='outputNumber'>{value}</span> of {key}
                    </div>)
                ) : (report?.indicatorType === "pre-def-multi" || report?.indicatorType === "pre-def-single")
                    ? report?.startingLevelList?.map((el) => <div className='outputNumberList'>{el}</div>) : <div>{text}</div>
            }
        },
        {
            title: intl.formatMessage({ id: 'target' }),
            dataIndex: 'targetLevel',
            key: 'targetLevel',
            render: (text, report) => {
                return (report?.indicatorType === "array-number" || report?.indicatorType === "array-percentage") && report?.targetLevelArray ? (
                    Object.entries(report?.targetLevelArray)?.map(([key, value]) => <div key={value}
                        className="statusButton"
                    ><span className='outputNumber'>{value}</span> of {key}
                    </div>)
                ) : (report?.indicatorType === "pre-def-multi" || report?.indicatorType === "pre-def-single")
                    ? report?.targetLevelList?.map((el) => <div key={el} className='outputNumber'>{el}</div>) : <div>{text}</div>
            }
        },
        {
            title: intl.formatMessage({ id: 'details' }),
            dataIndex: 'status',
            key: 'status',
            render: (text, report) => {
                return (
                    <Button
                        className="statusButton"
                        onClick={() => handleStatusClick(report)}
                    >
                        <EyeFilled />
                    </Button>
                );
            },
        },
    ];

    const oppIndicatorsColumns = [
        {
            title: intl.formatMessage({ id: 'name' }),
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: intl.formatMessage({ id: 'starting' }),
            dataIndex: 'startingLevel',
            key: 'startingLevel',
            render: (text, report) => {
                return (report?.indicatorType === "array-number" || report?.indicatorType === "array-percentage") && report?.startingLevelArray ? (
                    Object.entries(report?.startingLevelArray)?.map(([key, value]) => <div key={key}
                        className="statusButton"
                    ><span className='outputNumber'>{value}</span> of {key}
                    </div>)
                ) : <div>{text}</div>
            }
        },
        {
            title: intl.formatMessage({ id: 'target' }),
            dataIndex: 'targetLevel',
            key: 'targetLevel',
            render: (text, report) => {
                return (report?.indicatorType === "array-number" || report?.indicatorType === "array-percentage") && report?.targetLevelArray ? (
                    Object.entries(report?.targetLevelArray)?.map(([key, value]) => <div key={key}
                        className="statusButton"
                    ><span className='outputNumber'>{value}</span> of {key}
                    </div>)
                ) : <div>{text}</div>
            }
        },
        {
            title: intl.formatMessage({ id: 'details' }),
            dataIndex: 'status',
            key: 'status',
            render: (text, report) => {
                return (
                    <Button
                        className="statusButton"
                        onClick={() => handleStatusClick(report)}
                    >
                        <EyeFilled />
                    </Button>
                );
            },
        },
    ];

    if (Array.isArray(indicators) && indicators.length === 0) return <></>

    const generalIndicators = Array.isArray(indicators) && indicators?.filter(
        (item) => item.isGeneral === 'Y'
    );
    const oppIndicators = Array.isArray(indicators) && indicators?.filter((item) => item.isGeneral === 'N');

    return (
        <div className={baseClassName}>
            <div className='contentContainer'>
                <StyledText as="p" variant="H2" className='mainTitle'>
                    {intl.formatMessage({ id: "indicators" })}
                </StyledText>
                {generalIndicators?.length > 0 && <> <StyledText as="p" variant="B3d" className='mainTitle'>
                    {intl.formatMessage({ id: "general_indicators" })}
                </StyledText>
                    <Table
                        className="components-table-demo-nested generalIndicators"
                        columns={generalIndicatorsColumns}
                        dataSource={getColumnData(generalIndicators)}
                        pagination={false}
                    /></>}
                {oppIndicators?.length > 0 && <>
                    <StyledText as="p" variant="B3d" className='mainTitle'>
                        {intl.formatMessage({ id: "project_indicators" })}
                    </StyledText>
                    <Table
                        className="generalIndicators"
                        columns={oppIndicatorsColumns}
                        dataSource={getColumnData(oppIndicators)}
                        pagination={false}
                    /></>}
                {renderModal()}
            </div>
        </div>
    )
}

const StyledCharityIndicatorsPreview = styled(CharityIndicatorsPreview)`
&.charityIndicatorsPreview{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .outputNumber{
        background: #dee3ed;
        border-radius: 5px;
        padding: 1px 8px;
        border: 1px solid grey; 
    }
    .outputNumberList{
        background: #dee3ed;
        border-radius: 5px;
        padding: 1px 8px;
        border: 1px solid grey; 
        width: 50px;
        margin: 2px;
        text-align: center;
    }
    .contentContainer{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 35vw;
    }
    .mainTitle{
        margin-bottom: 20px;
    }

    .formContainer{
        display: flex;
        gap: 12px;
        flex-direction: column;
    }
    .generalIndicators{
        margin-bottom: 40px;
    }
    .overlay {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1000;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.45);
        }
    .spinner {
            z-index: 2000;
            margin: auto;
            left: 50%;
            right: 50%;
            position: absolute;
            bottom: 50%;
    }
    .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector{
        background: transparent !important;
    }

  .ant-form-item{
    margin-bottom: 10px;
  }

.statusButton{
    background: transparent in !important;
    border: 0 !important;
}

.downloadBtn {
  color: #5271FF !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  font-weight: bold !important;
  cursor: pointer;
}
.checkboxParentContainerFormItem.ant-form-item{
        margin-bottom: 0 !important;
    }

.checkboxParentContainer{
   
    .checkboxContainer{
        display: flex !important;
        flex-direction: column !important;
    }
}

.dropDownBackground{
  background: none;
  display: flex;
  flex-direction: column;
}
.fontBold{
  color: rgba(0, 0, 0, 0.65);
  font-weight: bold;
}

.marginBottom{
  margin-bottom: 24px !important;
  display: inline-block;
}

.optional ::after{
  display: none;
}

.marginLeft{
  margin-left: 15px !important;
}

.marginBottomStandard{
  margin-bottom: 12px !important;
  display: inline-block;
}

.delete{
  background: red;
}

.dFlex{
  display: flex;
  font-weight: 400;
}

.dFlexTop {
  display: flex;
  font-weight: 400;
  align-items: flex-start !important;
}

.whiteSpaceBreak {
  white-space: break-spaces;
  align-items: center;
}

.whiteSpaceBreak label{
  white-space: break-spaces;
}

.inputStyle input {
  width: 90px !important;
}

.selectBox {
  width: 150px !important;
}
}`;

export default StyledCharityIndicatorsPreview;